import { createStore, applyMiddleware, compose } from 'redux'
import reducer from './reducers'
import thunk from 'redux-thunk'

let store;
if (global.__main__store) {
  store = global.__main__store;
} else {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  store = global.__main__store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)))
}

export default store



// WEBPACK FOOTER //
// ./src/store.js